exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".items-box .content{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:1rem}.items-box.childgrow .content{grid-template-columns:1fr}@media screen and (max-width:800px){.items-box .content{grid-template-columns:1fr;grid-row-gap:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a8c2fe2a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content/elements/Items.vue
// module id = 134
// module chunks = 0